import React, { useState } from 'react';
import { Modal, Form } from 'antd';
import {
  useChangeWarrantyModalDispatch,
  useChangeWarrantyModalState,
} from '../../model';
import { formConfig, modalTitles, modes, warrantyIds } from '../../config';
import AddressFieldset from './components/AddressFieldset/AddressFieldset';
import DocFieldset from './components/DocFieldset/DocFieldset';
import { useWarrantyStateChange } from '../../api/mutations/useChangeWarrantyState';
import { transformValues } from './utils';

const getTitle = (modalData) => {
  if (!modalData) return '';
  const { request, mode } = modalData;
  const title = modalTitles[mode]?.(request?.id);
  return title || '';
};

const {
  fieldNames: { master: masterName, executer: executerName },
} = formConfig;

const garantyValues = {
  [modes.regularToPossWarranty]: warrantyIds.possWarranty,
  [modes.possWarrantyToWarranty]: warrantyIds.warranty,
  [modes.warrantyToRegular]: warrantyIds.notWarranty,
  [modes.possWarrantyToRegular]: warrantyIds.notWarranty,
};

const determineNeedOfAddressValues = (formValues, request) =>
  formValues.hasOwnProperty(masterName) &&
  formValues.hasOwnProperty(executerName) &&
  (formValues[masterName] !== request?.master?.id ||
    formValues[executerName] !== request?.executer?.id);

const ChangeModalContainer = ({ form, onSuccess }) => {
  const modalData = useChangeWarrantyModalState();
  const { close } = useChangeWarrantyModalDispatch();
  const { change, loading } = useWarrantyStateChange({ onSuccess });

  const [fileList, setFileList] = useState([]);

  const cancel = () => {
    form.resetFields();
    setFileList([]);
    close();
  };

  const handleSubmit = () => {
    form.validateFields(async (err, formValues) => {
      if (!err) {
        const needAddressValues = determineNeedOfAddressValues(
          formValues,
          modalData?.request
        );

        const values = transformValues({
          values: { ...formValues, file: fileList?.[0] },
          needAddressValues,
          needWarrantyDocValues: fileList?.length > 0,
        });

        await change({
          requestId: modalData?.request?.id,
          garantyId: garantyValues[modalData?.mode],
          ...values,
        });
        cancel();
      }
    });
  };

  return (
    <Modal
      title={getTitle(modalData)}
      visible={Boolean(modalData)}
      destroyOnClose
      confirmLoading={loading}
      onCancel={cancel}
      onOk={handleSubmit}
      bodyStyle={{ padding: '10px 24px' }}
    >
      <Form>
        {modalData?.mode !== modes.regularToPossWarranty ? (
          <DocFieldset
            form={form}
            fileList={fileList}
            setFileList={setFileList}
          />
        ) : null}

        {modalData?.mode !== modes.possWarrantyToWarranty ? (
          <AddressFieldset
            form={form}
            request={modalData?.request}
            mode={modalData?.mode}
          />
        ) : null}
      </Form>
    </Modal>
  );
};

const ChangeModal = Form.create({ name: 'change_request_warranty' })(
  ChangeModalContainer
);

export default ChangeModal;
